import { getConfig } from 'Helpers/Config';
const CONFIG = getConfig();

setTimeout(() => {
    (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { return; }
        js = d.createElement(s); js.id = id;
        js.src = `//maps.googleapis.com/maps/api/js?key=${CONFIG.GAPI_KEY}&callback=initMap`;
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'gmap-api'));
}, 300);



// WEBPACK FOOTER //
// ./src/addons/gmap.js